import React from 'react';

// Helpers
import { testGetUserMedia } from '../../helpers/helpers';

// Components
import Webcam from '../UserMedia/Webcam';

const IDVerification = class IDVerification extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.acceptPhoto = this.acceptPhoto.bind(this);
    this.next = this.next.bind(this);
    this.complete = this.complete.bind(this);

    // Set the initial state
    this.state = {
      ready: false,
      headshot: null,
      idFront: null,
      mediaChecked: false,
      getUserMedia: true,
      photo: 1,
      verifying: false,
      finished: false
    };
  }

  componentDidUpdate() {
    const { button, parent, sessionStartData, statusClass } = this.props;

    if(statusClass === 'slide-active') {
      // Skip if not enabled
      if(!sessionStartData.modalityOptions.verifyId) {
        parent.nextStep();
      }

      if(!button.disabled && !this.state.finished) {
        // Disable the continue button
        button.disabled = true;

        parent.setState({
          next: null
        });
      }

      // Check if getUserMedia is supported
      if(!this.state.mediaChecked) {
        const getUserMediaSupported = testGetUserMedia();
  
        if(!getUserMediaSupported) {
          this.setState({
            getUserMedia: false
          });
        }

        this.setState({
          mediaChecked: true
        });
      }

      // If getUserMedia has been checked and is available, set ready to true
      if(this.state.mediaChecked && this.state.getUserMedia && !this.state.ready) {
        this.setState({
          ready: true
        });
      }
    } else if(this.state.ready) {
      this.setState({
        ready: false
      });
    }
  }

  acceptPhoto(type) {
    const { examSid, onAccept, nextStep, sessionSid, sessionStartData, smarterId } = this.props;
    const { ScheduleStore, SessionStore, SmarterIDStore } = this.props.store;
    const translation = this.props.translation.id_verification;

    const data = {
      type,
      photo: this.state[type].src
    };

    const errorCallback = () => {
      let photo = 1;

      if(this.state.photo !== 1 || smarterId) {
        photo = 1;
        
        // Undo verification state to go back to retake headshots
        this.setState({
          verifying: false
        });

        // Show an error message
        SessionStore.showDialog(translation.failed);

        // Initiate retake
        const btn = document.querySelector('#SessionStartAutomated .webcam__retake');

        if(btn) {
          btn.click();
        }
      }

      this.setState({
        [type]: null,
        finished: false,
        photo
      });
    }
    // Logic for handling the response of uploading the headshots
    const responseCallback = (boolean) => {
      const { button } = this.props;
      
      this.setState({
        finished: boolean
      });
      button.disabled = !boolean;
    }
    
    if(smarterId) {
      SmarterIDStore.authenticateUser(
        sessionStartData.smarterId,
        data,
        errorCallback,
        nextStep
      );
    } else {
      ScheduleStore.uploadSessionPhoto(examSid, sessionSid, data, errorCallback, responseCallback, this.state.photo);

      if (this.state.photo === 2) {
        this.setState({ verifying: true })
      }
    }

    onAccept(type, type === 'headshot' ? this.state[type].src : null);
  }

  next() {
    this.setState({
      photo: this.state.photo + 1
    });
  }

  complete() {
    const { parent, nextStep } = this.props;

    this.setState({
      finished: false
    });

    parent.setState({
      next: nextStep
    });
  }

  render() {
    const { onCapture, smarterId, statusClass } = this.props;
    const translation = this.props.translation.id_verification;

    if(this.state.getUserMedia) {
      return (
        <main className={`panel panel--medium ${statusClass}`} aria-labelledby="step4">
          <h2 className="panel__title panel__title--alt" id="step4">
            {translation.heading}
          </h2>

          {this.state.ready && this.state.photo === 1 &&
            <Webcam
              {...this.props}
              allowCapture={true}
              onCapture={onCapture}
              onAccept={() => this.acceptPhoto('headshot')}
              name="headshot"
              camera="user"
              type="portrait"
              parent={this}
              caption={translation.headshot}
              disableFullScreen={true}
              callback={smarterId ? this.complete : this.next}
              complete={this.state.finished}
              completeText={translation.verifying}
              photo={this.state.photo}
            />
          }

          {this.state.ready && this.state.photo === 2 &&
            <Webcam
              {...this.props}
              allowCapture={true}
              onCapture={onCapture}
              onAccept={() => this.acceptPhoto('idFront')}
              name="idFront"
              camera="user"
              type="landscape"
              parent={this}
              caption={translation.id}
              disableFullScreen={true}
              callback={this.complete}
              complete={this.state.finished}
              completeText={!this.state.finished ? translation.verifying : translation.complete}
              verifying={this.state.verifying}
              photo={this.state.photo}
            />
          }
        </main>
      )
    } else {
      // Webcam recording not supported by the browser
      return (
        <div className={`panel panel--medium ${statusClass}`}>
          <h2 className="panel__title panel__title--alt">
            {translation.unsupported.heading}
          </h2>

          <p>{translation.unsupported.body}</p>
        </div>
      )
    }
  }
}

export default IDVerification;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/IDVerification.js